// extracted by mini-css-extract-plugin
module.exports = {"jenga-item":"index-module__jenga-item___2P9RJ","title":"index-module__title___1YRXW","body":"index-module__body___3ooDT"};